import type { CssVarsThemeOptions } from '@mui/material/styles';

import { lightScheme } from './light';
import { darkScheme } from './dark';

export const colorSchemes: CssVarsThemeOptions['colorSchemes'] = {
  light: lightScheme,
  dark: darkScheme,
};
